export default "__VITE_ASSET__Bif4Avxn__"